// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__Cq0PG","form":"styles_form__1QnBQ"};